'use client'

// Zählt Klicks auf direkte Hub-Links aus Newslettern (?nlk=…), siehe
// lib/newsletter-klick-client.ts. Sitzt im Root-Layout, damit auch Seiten ohne
// Login (Anmeldung, Terminbuchung, Newsletter-Portal) den Klick melden.
//
// useLayoutEffect statt useEffect: Layout-Effekte laufen vor allen normalen
// Effekten des Baums. Seiten, die ihre Adresse beim Laden selbst bereinigen
// (TalkoverDabei entfernt ?dabei=1 samt Query), würden den Parameter sonst
// wegräumen, bevor er gemeldet ist. Abhängig vom Pfad, damit auch ein
// Seitenwechsel im Router zählt (Sprung nach dem Login, App-Links).
// Bewusst kein useSearchParams: das bräuchte eine Suspense-Grenze im Root-Layout.
// Hier wird nur GEMELDET. Das Entfernen aus der Adresse wartet, bis Next
// window.history gepatcht hat (Begründung in lib/newsletter-klick-client.ts).
import { useLayoutEffect } from 'react'
import { usePathname } from 'next/navigation'
import { meldeNewsletterKlick } from '@/lib/newsletter-klick-client'

export default function NewsletterKlick() {
  const pathname = usePathname()
  useLayoutEffect(() => {
    meldeNewsletterKlick()
  }, [pathname])
  return null
}
